/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElRadioGroup as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("国内");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("海外");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("不限");
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "*必须上传PNG格式的图片;", -1);
import { apiAppGameAdd, apiAppGameUpdate } from '@/api/app';
import { ElForm } from 'element-plus';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['success'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      setGameInfo
    } = useAppStore();
    const ruleForm = ref();
    const form = reactive({
      Id: '',
      Name: '',
      Icon: [],
      PArea: 1
    });
    watch(() => props.gameInfo, game => {
      if (game && game.Id) {
        form.Id = game.Id;
        form.Name = game.Name;
        form.Icon = game.Icon;
        form.PArea = game.PArea;
      }
    }, {
      immediate: true
    });
    const loading = ref(false);
    const onSubmit = () => {
      ruleForm.value.validate(valid => {
        if (valid) {
          loading.value = true;
          const api = form.Id ? apiAppGameUpdate : apiAppGameAdd;
          api({
            Id: form.Id,
            Name: form.Name,
            Icon: Array.isArray(form.Icon) ? form.Icon[0] && form.Icon[0].url : form.Icon,
            PArea: form.PArea
          }).then(res => {
            if (res.code === 0) {
              setGameInfo(res.data);
              emits('success');
            }
          }).finally(() => {
            loading.value = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_radio = __unplugin_components_2;
      const _component_el_radio_group = __unplugin_components_3;
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_el_button = __unplugin_components_4;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_unref(ElForm), {
        ref_key: "ruleForm",
        ref: ruleForm,
        model: _unref(form),
        "label-width": "95px",
        labelAlign: "right"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "游戏名称",
          prop: "Name",
          rules: {
            required: true,
            message: '请输入游戏名称',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).Name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).Name = $event),
            placeholder: "请输入游戏名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "发行地区",
          prop: "PArea",
          rules: {
            required: true,
            message: '请选择发行地区',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: _unref(form).PArea,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).PArea = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "上传ICON"
        }, {
          default: _withCtx(() => [_createVNode(_component_u_upload, {
            modelValue: _unref(form).Icon,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).Icon = $event),
            limit: 1,
            "multi-part": "",
            listType: "picture-card",
            accept: ".png"
          }, {
            tip: _withCtx(() => [_hoisted_4]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            loading: loading.value,
            onClick: onSubmit
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.gameInfo && __props.gameInfo.Id ? '确认修改' : '创建游戏'), 1)]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});